import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

const contentMaxWidth = 1366

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: 'auto !important',
    maxWidth: contentMaxWidth,
    display: 'flex',
    flexDirection: 'column',
    margin: 0,
    padding: 0,
    position: 'relative',
  },
}))

export { useStyles }
